import {createAction, props} from '@ngrx/store';
import {AuthError} from '../models/auth-error';
import {Authenticate, Registration, RequestReset, Reset, User} from '../models/user';


// helper:

export interface UserAuthSuccessActionPayload {
    user: User;
}

// validate auth token

export const validateAuthToken = createAction(
    '[User] Validate auth token'
);

export const validateAuthTokenInvalid = createAction(
    '[User] Validate auth token invalid'
);

export const validateAuthTokenLoggedIn = createAction(
    '[User] Validate auth token logged in',
    props<UserAuthSuccessActionPayload>()
);

// login

export const login = createAction(
    '[User] Login',
    props<Authenticate>()
);

export const loginSuccess = createAction(
    '[User] Login success',
    props<UserAuthSuccessActionPayload>()
);

export const loginFailure = createAction(
    '[User] Login failure',
    props<{ authError: AuthError }>()
);

export const logout = createAction(
    '[User] Logout',
    props<{ requestedUrl?: string }>()
);

// password reset

export const requestReset = createAction(
    '[User] Request reset password',
    props<RequestReset>()
);

export const requestResetSuccess = createAction(
    '[User] Request reset password success'
);

export const requestResetFailure = createAction(
    '[User] Request reset password failure',
    props<{ authError: AuthError }>()
);

export const reset = createAction(
    '[User] Reset password',
    props<Reset>()
);

export const resetSuccess = createAction(
    '[User] Reset password success'
);

export const resetFailure = createAction(
    '[User] Reset password failure',
    props<{ authError: AuthError }>()
);

// registration

export const registration = createAction(
    '[User] Registration',
    props<Registration>()
);

export const registrationSuccess = createAction(
    '[User] Registration success',
);

export const registrationFailure = createAction(
    '[User] Registration failure',
    props<{ authError: AuthError }>()
);

// access

export const accessDenied = createAction(
    '[User] Access denied',
    props<{ requestedUrl: string }>()
);

export const accessGranted = createAction(
    '[User] Access granted'
);
